const ValidationTypes = {
  ERROR: "error",
  WARNING: "warning",
  NONE: ""
};

ValidationTypes.ALL = Object.values(ValidationTypes);

export default ValidationTypes;
